/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import BarcodeReader from "react-barcode-reader";
import { useQuery } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import Container from "../components/container/Container";
import Banner from "../components/hero/Banner";
import Header from "../components/header/Header";
import SuccessFlash from "../components/flash_message/SuccessFlash";
import ErrorFlash from "../components/flash_message/ErrorFlash";
import FormValidationError from "../components/flash_message/FormValidationError";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import useAuth from "../hooks/useAuth";
import { playBeepingSound } from "../utils/playSound";
import ModalDrop from "../components/modals/ModalDrop";
import ScanError from "../components/scanning-error/ScanError";
import style from "./pages.module.css";
import SolidButton from "../components/buttons/solid-button/SolidButton";

const SetChildren = styled.div`
	margin-top: 18px;
	width: 100%;
`;

const Input = styled.input`
	width: ${(props) => props.width};
	border: 1px solid #d6d6d6;
	color: black;
	font-size: 16px;
	border-radius: 5px;
	height: 40px;
	padding: 0 5px;
`;

const FormInputControl = styled.div`
	width: 100%;
	margin: 10px 0;
`;

const PackageList = () => {
	const axiosprivate = useAxiosPrivate();
	const location = useLocation();
	const { auth, setLoading } = useAuth();
	const [barcode, setBarcode] = useState("Scan barcode...................");
	const [longitude, setLongitude] = useState("");
	const [latitude, setLatitude] = useState("");
	const [isSuccess, setIsSuccess] = useState(false);
	const [isFail, setIsFail] = useState(false);
	const navigate = useNavigate();
	const [message, setMessage] = useState("Success");
	const [incompleteScan, setIncompleteScan] = useState(false);
	const [scanError, setScanError] = useState({ show: false, barcode: "" });
	const [enableQuery, setEnableQuery] = useState(false);
	const [listKey, setListKey] = useState(0);

	useEffect(() => {
		navigator.permissions.query({ name: "geolocation" }).then((resp) => {
			if (resp.state === "granted") {
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(success, error);
				}
			} else if (resp.state === "denied") {
				navigate("/", { state: { from: location }, replace: true });
			}
		});

		function success(position) {
			setLatitude(`${position.coords.latitude}`);
			setLongitude(`${position.coords.longitude}`);
		}

		function error(err) {
			//TASK: remove the lng and lat from the below error log and use them properly or remove them totally
			console.error({ err, longitude, latitude });
			navigate("/", { state: { from: location }, replace: true });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const validateCode = async (elementString) => {
		const clientId = auth.user.clientId || 4;
		return await axiosprivate.get(
			`/gs1/standard/label/check/${clientId}/${elementString}/pack`,
		);
	};

	//get barcodes
	const handleScan = async (data) => {
		setIncompleteScan(false);
		setBarcode(data);
		setIsFail(false);
		setIsSuccess(false);
		setLoading(true);

		await validateCode(data)
			.then(() => {
				if (
					data.substring(0, 2) === "00" &&
					data.substring(3, 6) === "615"
				) {
					if (data.length < 20) {
						setIncompleteScan(true);
						return;
					}
				} else {
					//SGTIN labels
					if (data.length < 40) {
						setIncompleteScan(true);
						return;
					}
				}
				setEnableQuery(true);
			})
			.catch((error) => {
				setLoading(false);
				console.error({ error });
				setScanError({
					show: true,
					errorMessage: "Faulty barcode please use a different label",
					barcode: data,
				});
				playBeepingSound();
			});
	};

	//handle error
	function handleError(err) {
		console.error(err);
	}

	const allPackages = useQuery(
		"all-packages",
		() => {
			return axiosprivate.get(
				`/gs1/standard/label/pack/pack-content/${barcode}?clientId=${auth.user.clientId || 4}`,
			);
		},
		{
			onError: (err) => {
				setEnableQuery(false);
				if (err.code === "ERR_NETWORK")
					setMessage("Please Check Your Network");
				else if (
					err?.response?.status === 401 ||
					err?.response?.status === 401
				)
					navigate("/", { state: { from: location }, replace: true });
				else setMessage(err?.response?.data?.message);
			},
			onSuccess: () => {
				setEnableQuery(false);
			},
			enabled: enableQuery,
			refetchOnMount: false,
		},
	);

	const resetScanError = () => {
		setScanError({ show: false, barcode: "" });
	};

	const resetToParent = () => {
		setBarcode("");
		allPackages.remove();
		setListKey((prev) => prev + 1);
	};

	useEffect(() => {
		setLoading(allPackages.isFetching);
	}, [allPackages.isFetching]);

	return (
		<Container>
			{scanError.show && (
				<ModalDrop>
					<ScanError
						onClose={resetScanError}
						barCode={scanError.barcode}
						errorMessage={scanError.errorMessage}
					/>
				</ModalDrop>
			)}
			<Header>{"View Packages"}</Header>
			<Banner />
			<div>
				<p>
					Total items (
					{allPackages.data?.data?.data?.children?.length ?? 0})
				</p>
				<small
					style={{
						fontSize: "12px",
						marginTop: "8px",
						display: "block",
					}}
				>
					Please click on the "scan barcode" field first, then scan a
					parent pack label to see all label items inside.
				</small>
			</div>

			<SetChildren>
				<BarcodeReader
					onError={handleError}
					onScan={handleScan}
					timeBeforeScanTest={1000}
				/>
				<FormInputControl>
					<Input
						value={barcode}
						width={"100%"}
						style={{ fontSize: "12px" }}
						disabled
					/>
					{incompleteScan && (
						<FormValidationError
							text={"Incomplete scan.. please rescan!!!!"}
						/>
					)}
				</FormInputControl>
			</SetChildren>

			<FormInputControl style={{ marginTop: "20px" }}>
				<SuccessFlash display={isSuccess}>{message}</SuccessFlash>
			</FormInputControl>

			<FormInputControl style={{ marginTop: "20px" }}>
				<ErrorFlash display={isFail}>{message}</ErrorFlash>
			</FormInputControl>

			{allPackages.data?.data?.data?.children?.length > 0 && (
				<SolidButton
					width={"100%"}
					text={"Reset Parent"}
					onclick={resetToParent}
				/>
			)}

			<section className={style.package_list} key={listKey}>
				{allPackages?.data?.data?.data?.children?.map((eachPack, i) => (
					<div key={eachPack} className={style.package_item_wrapper}>
						<span>{i + 1}</span>
						<div className={style.package_list_item}>
							<p>{eachPack}</p>
						</div>
					</div>
				))}
			</section>
		</Container>
	);
};

export default PackageList;
